import { render, staticRenderFns } from "./OpcionesAreaChat.vue?vue&type=template&id=75cf9f1a"
import script from "./OpcionesAreaChat.vue?vue&type=script&lang=js"
export * from "./OpcionesAreaChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports